import * as React from 'react';
import styled from 'styled-components';
import './fieldStyles.less';
import { StyledLegend } from './StyledElements';

const Fieldset = (props: Props) => {
	const { title, ...otherProps } = props;
	return (
		<Element
			className={`fieldset${!props.className ? '' : ` ${props.className}`}`}
			disabled={props.disabled}
			ref={props.fieldsetRef}
		>
			{title && <StyledLegend centred={props.centred}>{title}</StyledLegend>}
			{otherProps.children}
		</Element>
	);
};

interface Props {
	title?: string;
	className?: string;
	children?: JSX.Element | JSX.Element[] | React.ReactNode[];
	disabled?: boolean;
	fieldsetRef?: React.RefObject<HTMLFieldSetElement>;
	centred?: boolean;
}

Fieldset.defaultProps = {
	title: null,
	className: null,
	children: null,
	disabled: false,
	fieldsetRef: null,
	centred: false
};

export default Fieldset;

const Element = styled.fieldset`
	padding: 0;
`;
